import { IDownloadOcorrenciaInspecaoPatrimonioArquivoUseCase } from "../../../presentation/useCases/read/download_ocorrencia_inspecao_patrimonio_arquivo_use_case";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * DownloadOcorrenciaInspecaoPatrimonioArquivoUseCase
 */

export class DownloadOcorrenciaInspecaoPatrimonioArquivoUseCase
  implements IDownloadOcorrenciaInspecaoPatrimonioArquivoUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async downloadOcorrenciaInspecaoPatrimonioArquivo(
    idOcorrenciaInspecaoPatrimonio: number,
    imageName: string,
    nrArquivo: number,
  ): Promise<void> {

    const blob = await this.repository.downloadOcorrenciaInspecaoPatrimonioArquivos(
      idOcorrenciaInspecaoPatrimonio,
      nrArquivo,
    );

    if (!blob) throw new Error('Falha ao buscar dados da imagem!');
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', String(imageName));
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

  }
}
